export default "__VITE_ASSET__BEwR9RXZ__"